/* eslint-disable no-constant-binary-expression */
import {ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter } from "@angular/router";
import { initializeApp } from 'firebase/app';
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { routes } from "./app.routes";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { GetInterceptorService } from "./core/interceptor/get-interceptor.service";
import { ConfirmationService, MessageService } from "primeng/api";
import {  SetInterceptorService } from "./core/interceptor/set-interceptor.service";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from "../environments/environment";
initializeApp(environment.firebaseConfig);
let swUrl: string;
if (typeof window === 'undefined') {
  swUrl = '/custom-sw.js';
} else if (window.location.hostname === 'localhost') {
  swUrl = '/custom-sw.js'; // dev
} else{
  swUrl = 'https://admin.teyssirapp.com/custom-sw.js'; // prod sub-path
}

export function HttpLoaderFactory(http: HttpClient) : any {
  return  new  TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: { mode: 'light', darkModeSelector: 
          false || 'none'}
    }
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideServiceWorker(swUrl, {
      enabled: true,
      registrationStrategy: 'registerWhenStable:3000'
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetInterceptorService,
      multi: true
    },
    TranslateService,
    MessageService,
    ConfirmationService,
    DialogService,
    DynamicDialogRef
  ],
};
